import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { FileService } from 'src/app/services/file.service';
import { map } from 'rxjs/operators';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { LineStatus } from './file-audit-changeStatusLineDialog/changeStatusLineDialog';

@Injectable({
    providedIn: 'root',
})
export class FileAuditService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private fileService: FileService,
        public authServiceCustom: AuthServiceCustom,
    ) {}

    getReceivingLinesSaleOff(params: any): Observable<any> {
        return this.http.get(`${this.API_URL}Receiving/Lines/SaleOff`, params);
    }

    getReceivingLinesRecordedCharge(params: any): Observable<any> {
        return this.http.get(`${this.API_URL}Receiving/Lines/RecordedCharge`, params);
    }

    countRecordedCharge(params: any) {
        return this.http.get<ResponseCustom>(`${this.API_URL}Receiving/Lines/CountRecordedCharge`, params);
    }

    countStatus(params: any) {
        return this.http.get<ResponseCustom>(`${this.API_URL}Receiving/Lines/CountStatus`, params);
    }

    sendReceivingLineFromProcess(params: any) {
        return this.http.post<ResponseCustom>(`${this.API_URL}Receiving/Lines/ProcessFile`, params);
    }

    financialReport(receivingBatchId: string): Observable<Blob> {
        return this.http.get(
            `${this.API_URL}afs-report/FinancialReceivingDetailedReport?receivingBatchId=${receivingBatchId}`,
            {
                responseType: 'blob',
            },
        );
    }

    processAll(batchId: string, params?: any) {
        return this.http.post<ResponseCustom>(`${this.API_URL}Receiving/Lines/Batch/${batchId}/ProcessAll`, params);
    }

    RegisteredChargeProcessAll(batchId: string, limit: any, params?: any) {
        return this.http.post<ResponseCustom>(
            `${this.API_URL}Receiving/Lines/Batch/${batchId}/${limit}/RegisteredChargeProcessAll`,
            params,
        );
    }

    sendReceivingLineFromSave(params: any) {
        return this.http.post<ResponseCustom>(`${this.API_URL}Receiving/Lines/SaveChangeLine`, params);
    }

    accountBatch(batchId: string, dateSelected: any): Observable<any> {
        return this.http.post(`${this.API_URL}Receiving/Batch/${batchId}/Account`, { dateSelected: dateSelected });
    }

    changeStatuReceivingBatch(id: string, processStatusId: number) {
        return this.http.patch(`${this.API_URL}Receiving/Batch/${id}/ChangeStatus`, processStatusId);
    }

    getReceivingBacthForId(batchId: string) {
        return this.http.get<ResponseCustom>(`${this.API_URL}Receiving/Batch/${batchId}`);
    }

    exportReceivingLines(receivingBatchId: string) {
        return this.http
            .get(`${this.API_URL}Receiving/Lines/ExportReceivingLines/${receivingBatchId}`, {
                responseType: 'arraybuffer',
                observe: 'response',
            })
            .pipe(
                map((httpResponse: HttpResponse<ArrayBuffer>) =>
                    this.fileService.extractFileNameAndBlobService(httpResponse),
                ),
            );
    }

    DeleteDuplicateSaleOff(id: number): Observable<any> {
        return this.http.delete(`${this.API_URL}Receiving/Lines/DeleteDuplicateSaleOff/${id}`);
    }

    checkPermissionToChangeStatusLine(): Observable<any> {
        let username = this.authServiceCustom.userName;
        return this.http.get(`${this.API_URL}Receiving/Lines/CheckPermissionToChangeStatusLine/${username}`);
    }

    ChangeStatusLine(receivingLineId: string[], status: LineStatus): Observable<any> {
        let model = { receivingLineIds: receivingLineId, status: status };
        return this.http.put(`${this.API_URL}Receiving/Lines/ChangeStatusLine`, model);
    }

    QueueToStandBy(receivingBatchId: string): Observable<any> {
        return this.http.put(`${this.API_URL}Receiving/Lines/QueueToStandBy/${receivingBatchId}`, null);
    }

    ProcessingToStandBy(receivingBatchId: string): Observable<any> {
        return this.http.put(`${this.API_URL}Receiving/Lines/ProcessingToStandBy/${receivingBatchId}`, null);
    }

    reloadReceivingLine(id: string): Observable<any> {
        return this.http.post(`${this.API_URL}Receiving/Lines/ReloadLine`, { Id: id });
    }
}
